import React, { useState, useRef, useEffect } from "react";

export const Header = (props) => {
  const { data, lang } = props;
  const [showText, setShowText] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(err => console.log("Otomatik oynatma bekletildi:", err));
    }

    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 1500);

    const videoTimer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.pause(); 
      }
    }, 4800);

    return () => {
      clearTimeout(textTimer);
      clearTimeout(videoTimer);
    };
  }, []);

  // =========================================================================
  // YENİ: SAYFAYI YENİLEMEDEN HAKKIMIZDA KISMINA KAYDIRAN FONKSİYON
  // =========================================================================
  const handleScrollToAbout = (e) => {
    e.preventDefault(); // Sayfanın yenilenmesini kesinlikle engeller
    const target = document.getElementById("about");
    
    if (target) {
      const headerOffset = 80; // Üst menünün (navbar) yüksekliği kadar pay bırakır
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth" // Pürüzsüz kaydırma
      });
    }
  };

  if (!data) return null;

  return (
    // YENİ: BackgroundColor #171717 (Kömür Siyahı) yapıldı
    <header id="header" style={{ position: "relative", width: "100%", height: "100vh", overflow: "hidden", backgroundColor: "#171717" }}>
      
      <video
        ref={videoRef}
        autoPlay 
        muted
        playsInline 
        loop 
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0, 
          objectFit: "cover", 
          objectPosition: "center", 
        }}
      >
        <source src={process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/img/BG.mp4` : "/img/BG.mp4"} type="video/mp4" />
        Tarayıcınız video etiketini desteklemiyor.
      </video>

      <div 
        className="intro" 
        style={{ 
          position: "relative", 
          width: "100%", 
          height: "100%", 
          background: "transparent",
          zIndex: 1 
        }}
      >
        <div 
          className="overlay" 
          style={{ 
            position: "absolute", 
            top: 0, 
            left: 0, 
            width: "100%", 
            height: "100%", 
            // YENİ: rgba(23, 23, 23, 0.55) -> Kömür Siyahı %55 Saydam Filtre
            backgroundColor: "rgba(23, 23, 23, 0.55)" 
          }}
        >
          <div className="container" style={{ height: "100%", display: "flex", alignItems: "center" }}>
            <div className="row" style={{ width: "100%" }}>
              
              <div 
                className={`col-xs-12 col-md-10 col-md-offset-1 intro-text ${showText ? 'text-fade-in' : 'text-hidden'}`}
                style={{
                  position: "relative",
                  zIndex: 2, 
                  opacity: 0, 
                  transform: "translateY(30px)", 
                  transition: "opacity 1.5s ease-out, transform 1.5s ease-out", 
                }}
              >
                <h1>
                  {data.title}
                  <span></span>
                </h1>
                
                <p>{data.paragraph}</p>
                
                {/* GÜNCELLENDİ: <a> etiketi <button> yapıldı ve onClick eklendi */}
                <button
                  onClick={handleScrollToAbout}
                  className="btn btn-custom btn-lg page-scroll"
                >
                  {lang === "tr" ? "Daha Fazla Bilgi Edin" : lang === "ru" ? "Узнать больше" : "Learn More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style>
        {`
          .text-fade-in {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
          .text-hidden {
            opacity: 0 !important;
            transform: translateY(30px) !important;
          }

          /* ================================================================= */
          /* YENİ TEMA OVERRIDE: GİRİŞ BUTONU TURUNCU VE SİYAH                 */
          /* ================================================================= */
          .intro-text .btn-custom {
            background-color: #e5882a !important;
            border: 2px solid #e5882a !important;
            color: #171717 !important;
            font-weight: 700;
            transition: all 0.3s ease;
          }
          .intro-text .btn-custom:hover {
            background-color: transparent !important;
            color: #e5882a !important;
            border: 2px solid #e5882a !important;
          }
        `}
      </style>

    </header>
  );
};